import { Component, forwardRef, Injectable, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { DvsUtilities } from "src/app/dvs-utilities";

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = "-";

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				year: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				day: parseInt(date[2], 10)
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return DvsUtilities.FormatNgbDate(date, null);
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = "-";

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				year: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				day: parseInt(date[2], 10)
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return DvsUtilities.FormatNgbDate(date, "");
	}
}

@Component({
	selector: "app-day-picker",
	templateUrl: "./day-picker.component.html",
	styleUrls: ["./day-picker.component.scss"],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => DayPickerComponent),
		multi: true,
	},
	{ provide: NgbDateAdapter, useClass: CustomAdapter },
	{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
	]
})
export class DayPickerComponent implements ControlValueAccessor {
	@Input()
	allowedDates: NgbDate[];

	private _value: any = null;
	// Whatever name for this (myValue) you choose here, use it in the .html file.
	public get myValue(): any { return this._value }
	public set myValue(v: any) {
		if (v !== this._value) {
			this._value = v;
			this.onChange(v);
		}
	}

	// constructor(private dateAdapter: NgbDateAdapter<string>) { }

	/* eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars */
	onChange = (_) => { };
	/* eslint-disable-next-line @typescript-eslint/no-empty-function */
	onTouched = () => { };

	writeValue(value: any): void {
		this._value = value;
	}
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	// Have to set function as a var to preserve context
	public isDisabled = (date: NgbDate) => {
		if (this.allowedDates) {
			return !this.allowedDates.find(item => item.day === date.day && item.month === date.month && item.year === date.year);
		} else {
			return false;
		}
	};
}
